<script>
  import { createEventDispatcher } from 'svelte'
  import Icon from '../Icon.svelte'

  export let query
  export let searchInput

  const dispatch = createEventDispatcher()

  function handleInput (e) {
    e.preventDefault()
    dispatch('input', query)
  }

  function handleClose (e) {
    e.preventDefault()
    dispatch('close', query)
  }
</script>

<div class="flex space-x-2 border-b-2 border-black">
  <div class="w-[18px] md:w-4 shrink-0 svg-fill text-black">
    <Icon name="search"/>
  </div>
  <input type="search" name="" placeholder="Search by winner name"
    class="w-full font-bold text-base leading-[1.23] md:leading-normal appearance-none rounded-none bg-transparent pb-1 focus:outline-none placeholder:text-black"
    bind:value={query}
    bind:this={searchInput}
    on:keyup={handleInput}
  >
  <button class={`w-3 shrink-0 svg-fill ${!query ? 'md:hidden' : ''}`} on:click={handleClose} >
    <Icon name="close"/>
  </button>
</div>